import Vue from 'vue';
import axios from 'axios';
import store from '../../store';
import Cookies from 'js-cookie';
import router from '../../router';
const URL_DOMAIN_TYPE = {
  '': process.env.VUE_APP_HOST,
  orgApi: process.env.VUE_APP_ORG_HOST,
  bpmApi: process.env.VUE_APP_BPM_HOST,
  dfsApi: process.env.VUE_APP_DFS_HOST
};

const $ajax = axios.create();// 修改名称  抽取所有的URL作为一个配置对象
$ajax.defaults.withCredentials = true;
Vue.prototype.$ajax = $ajax;
// ajax缓冲动画

const loading = document.getElementsByClassName('loadingWrap')[0];
const body = document.getElementsByTagName('body')[0];

const getCookies = function () {
  const cooList = Cookies.get();
  let result = '';
  console.log(cooList);
  for (const key in cooList) {
    if (key == 'token') {
      // result += `${key}=${cooList[key]}; `;
      result += `${cooList[key]}`;
    }
  }
  return result;
};

// 向服务器发出请求时
$ajax.interceptors.request.use(config => {
  const { noUseGlobalLoading = false } = config;
  if (!noUseGlobalLoading) {
    loadingShow();
    store.commit('changeLoadingState', true);
  }
  if (process.env.NODE_ENV == 'development') {
    const token = Cookies.get('Admin-token', { domain: process.env.VUE_APP_TOKEN_DOMAIN });
    if (token != undefined) {
      config.headers['X-Token-91'] = token;
    }
  }
  const prefixProtocol = process.env.VUE_APP_PREFIXPROTOCOL;
  let { domainType } = config;
  if (!domainType) {
    domainType = '';
  }
  if (!domainType) { // 如果是自身的接口就穿个true
    config.headers['X-Refresh-Token-91'] = true;
  }
  config.url = prefixProtocol + URL_DOMAIN_TYPE[domainType] + config.url;
  return config;
}, err => {
  console.error(err);
});

// 数据返回时
$ajax.interceptors.response.use(function (response) { // 对返回的数据进行一些处理
  store.commit('changeLoadingState', false);
  loadingHide();
  loading.className = 'loadingWrap';
  body.setAttribute('style', 'overflow: scroll');
  if (response.data && response.data.code) {
    if (response.data.code == 100403) {
      alert(response.data.msg || '错误，请联系相关人员');
      router.push('/401');
    } else if (response.data.code !== 200) {
      alert(response.data.msg || '错误，请联系相关人员');
    }
  }
  return response;
}, (error) => {
  store.commit('changeLoadingState', false);
  loadingHide();
  if (error.response && error.response.data && error.response.data.code) {
    if (error.response.data.code == 401 || error.response.data.code == 402 || error.response.data.code == 403 || error.response.data.code == 100403) {
      if (error.response.data.code == 401) {
        alert('登录失效，请重新登录');
        Cookies.remove('Admin-token', { domain: process.env.VUE_APP_TOKEN_DOMAIN });
        router.push('/login');
      } else if (error.response.data.code == 100403) {
        router.push('/401');
      } else {
        alert(error.response.data.msg || '服务器响应异常（状态：002），请重新登录系统！');
      }
    } else if (error.response.data.msg) {
      alert(error.response.data.msg);
    } else {
      alert('服务器响应异常（状态：001），请刷新页面，重新尝试！');
    }
  } else {
    alert('网络异常，请重新操作');
    // window.location.reload(); // 兼容Safari 取消ajax的情况
  }
  return Promise.reject(error);
});
function loadingShow () { // 显示loading效果
  loading.className = 'loadingWrap active';
  body.setAttribute('style', 'overflow: hidden');
}
function loadingHide () { // 隐藏loading效果
  if (store.state.axios.loadingCount <= 0) {
    loading.className = 'loadingWrap';
    body.setAttribute('style', 'overflow: scroll');
  }
}
export default $ajax;
